export const formatDateYYYYMMDD = (isoDateTime) => {
  const date = new Date(isoDateTime);
  // Extract the date components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = String(date.getFullYear()).slice(0); // Get the last two digits of the year

  // Format the date as "yy-mm-dd"
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
};

export const formatDate  = (isoDateTime) => {
  const date = new Date(isoDateTime);
    
  // Extract the date components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = String(date.getFullYear()).slice(0); // Get the last two digits of the year

  // Format the date as "dd/mm/yy"
  const formattedDate = `${day}/${month}/${year}`;
    
  return formattedDate;
};

export const formatDateDDMMYYYY = (isoDateTime) => {
  const date = new Date(isoDateTime);
  // Extract the date components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = String(date.getFullYear()).slice(0); // Get the last two digits of the year

  // Format the date as "yy-mm-dd"
  const formattedDate = `${day}/${month}/${year}`;

  return formattedDate;
};

export const formatDateTxt = (isoDateTime) => {
  const date = new Date(isoDateTime);
    
  // Array of month abbreviations
  const monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Extract the date components
  const day = String(date.getDate()).padStart(2, '0');
  const month = monthAbbreviations[date.getMonth()]; // Get the month abbreviation
  const year = String(date.getFullYear()).slice(0); // Get the full year

  // Format the date as "DD/MMM/YYYY"
  const formattedDate = `${day} ${month} ${year}`;
    
  return formattedDate;
};

export const formatDateTxt2 = (dateStr) => {
  const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  const [day, month, year] = dateStr.split('/');
  return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
};